import { render, staticRenderFns } from "./DeleteCommissionDialog.vue?vue&type=template&id=8531aae8&scoped=true"
import script from "./DeleteCommissionDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCommissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531aae8",
  null
  
)

export default component.exports